<template>
  <TransitionGroup
    tag="ul"
    class="fixed inset-0 flex h-full flex-col sm:flex-col-reverse items-end justify-end content-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-start z-30"
    :enter-active-class="messages.length > 1 ? 'transform ease-out duration-300 transition delay-300' : 'transform ease-out duration-300 transition'"
    enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
    move-class="transition duration-200 ease-in-out"
  >
    <component
      :is="message.type"
      v-for="(message, index) in messages"
      :message="message"
      :key="message.guid"
      @close="remove(message)"
      class="mb-4"
    />
  </TransitionGroup>
</template>

<script>
import _without from 'lodash-es/remove'

import Message from '@/components/FlashMessage.vue'
import Error from '@/components/FlashError.vue'
import Success from '@/components/FlashSuccess.vue'

export default {
  components: {
    Error,
    Success,
    Message
  },
  data() {
    return {
      messages: []
    }
  },

  mounted() {
    Bus.$on('flash-message', message => {
      this.message = message
      message["guid"] = this.generateGuid()
      if (!message.type) {
        message["type"] = 'flash-message'
      }
      this.messages = [message, ...(this.messages.slice(0, 2))]
    })
  },

  methods: {
    generateGuid() {
      var result, i, j;
      result = '';
      for(j=0; j<32; j++) {
        if( j == 8 || j == 12 || j == 16 || j == 20)
          result = result + '-';
        i = Math.floor(Math.random()*16).toString(16).toUpperCase();
        result = result + i;
      }
      return result;
    },

    remove(message) {
      this.messages = this.messages.filter(n => n.guid !== message.guid)
    }
  },

}
</script>
